import styled from "styled-components";

import Bg from '@/static/images/snap/bg.png'

export const Root = styled.div`
  padding-top: 208px;
  min-height: 100vh;
  box-sizing: border-box;
  background: url(${Bg}) no-repeat;
  background-size: cover;

  &.mobile {
    min-height: 0;
    background: none;
    padding: 100px 18px 0;

    .snap {
      flex-direction: column-reverse;
    }

    .info {
      margin-top: 10px;

      h1, h2 {
        line-height: 26px;
        font-size: 20px;
      }
    }

    .desc {
      margin-top: 15px;
      font-size: 12px;
      line-height: 16px;
    }

    .btn {
      margin-top: 30px;

      a {
        justify-content: center;
        width: 162px;
        height: 35px;
        border-radius: 10px;

        svg {
          transform: scale(0.8);
        }
      }
    }

    .pic {
      margin: 0 auto;
      position: static;
      max-width: 100%;

      img {
        width: 95vw;
        max-width: 595px;
      }
    }
  }

  .snap {
    display: flex;
    justify-content: space-between;
  }

  .info {
    h1, h2 {
      line-height: 58px;
      font-family: Inter, Inter;
    }
    h1 {
      font-size: 42px;
      color: #E0341A;
    }
    h2 {
      font-size: 38px;
    }
  }

  .desc {
    margin-top: 30px;
    font-size: 18px;
    color: #999999;
    line-height: 22px;
  }

  .btn {
    margin-top: 80px;

    a {
      justify-content: center;
      width: 210px;
      height: 45px;
      background: #FEC492;
      color: #000000;

      svg {
        margin-right: 10px;
      }

      &:hover {
        box-shadow: 1px 2px 9px 0px rgba(254, 196, 146, 0.6);
      }

      &.disabled {
        cursor: not-allowed;
        transition: none;
        background: #bcbcbc;
        border-color: #bcbcbc;
        color: #fff;

        &:hover {
          background: #bcbcbc;
          transform: none;
          box-shadow: none;
        }
      }
    }
  }

  .pic {
    margin-left: 30px;
    position: relative;
    right: -50px;
    top: 24px;
  }
`
